import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isAgentTypeEnabled, isAISidepanelEnabled} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

// Must stay in sync with SUPPORTED_CHART_TYPES in
// benchling/notebook/ai_tools/ai_tools/suggest_plots.py.
export const SUPPORTED_CHART_TYPES = [
  'bar',
  'line',
  'scatter',
  'pie',
  'area',
  'histogram',
  'box',
  'heatmap',
] as const;

export type PlotChartType = (typeof SUPPORTED_CHART_TYPES)[number];

export interface PlotSuggestion {
  title: string;
  description: string;
  chartType: PlotChartType;
  xAxis: string | null;
  yAxis: string | null;
  prompt: string;
}

export interface SuggestPlotsResponse {
  tableName: string;
  suggestions: Array<PlotSuggestion>;
  hadError: boolean;
  errorMessage: string | null;
}

const CHART_TYPE_TO_ICON: Record<PlotChartType, BenchlingIconName> = {
  bar: 'chart-column',
  line: 'chart-line',
  scatter: 'chart-scatter',
  pie: 'chart-pie',
  area: 'chart-area',
  histogram: 'chart-column',
  box: 'chart-simple',
  heatmap: 'table-cells',
};

const DEFAULT_CHART_ICON: BenchlingIconName = 'chart-simple';

export function getIconForChartType(chartType: string): BenchlingIconName {
  return CHART_TYPE_TO_ICON[chartType as PlotChartType] ?? DEFAULT_CHART_ICON;
}

export function arePlotSuggestionsSupported(llmEnableSuggestedPlots: boolean): boolean {
  return llmEnableSuggestedPlots && isAISidepanelEnabled() && isAgentTypeEnabled(AgentType.ASSISTANT);
}
